import ACTIONS from "./SettingsActionTypes";

const initialState = {
  getSettingsLoading: false,
  getSettingsResponse: null,
  postSettingsLoading: false,
  postSettingsResponse: null,
  //CUSTOM ROLE
  getCustomRoleListLoading: false,
  getCustomRoleListResponse: null,
  postCustomRoleLoading: false,
  postCustomRoleResponse: null,
  getCustomRoleLoading: false,
  getCustomRoleResponse: null,
  putCustomRoleByPermissionLoading: false,
  putCustomRoleByPermissionResponse: null,
  getCustomRoleByPermissionLoading: false,
  getCustomRoleByPermissionResponse: null,
};

const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_SETTINGS_REQUEST:
      return {
        ...state,
        getSettingsLoading: true,
      };
    case ACTIONS.GET_SETTINGS_RESPONSE:
      return {
        ...state,
        getSettingsLoading: false,
        getSettingsResponse: action.payload,
      };
    case ACTIONS.POST_SETTINGS_REQUEST:
    case ACTIONS.PUT_SETTINGS_REQUEST:
      return {
        ...state,
        postSettingsLoading: true,
      };
    case ACTIONS.POST_SETTINGS_RESPONSE:
    case ACTIONS.PUT_SETTINGS_RESPONSE:
      return {
        ...state,
        postSettingsLoading: false,
        postSettingsResponse: action.payload,
      };
    case ACTIONS.POST_SETTINGS_RESPONSE_CLEAR:
      return {
        ...state,
        postSettingsResponse: null,
      };
    //CUSTOM ROLES
    case ACTIONS.GET_CUSTOM_ROLE_LIST_REQUEST:
      return {
        ...state,
        getCustomRoleListLoading: true,
      };
    case ACTIONS.GET_CUSTOM_ROLE_LIST_RESPONSE:
      return {
        ...state,
        getCustomRoleListLoading: false,
        getCustomRoleListResponse: action.payload.data,
      };
    case ACTIONS.GET_CUSTOM_ROLE_REQUEST:
      return {
        ...state,
        getCustomRoleLoading: true,
      };
    case ACTIONS.GET_CUSTOM_ROLE_RESPONSE:
      return {
        ...state,
        getCustomRoleLoading: false,
        getCustomRoleResponse: action.payload,
      };
    case ACTIONS.POST_CUSTOM_ROLE_REQUEST:
    case ACTIONS.PUT_CUSTOM_ROLE_REQUEST:
    case ACTIONS.PUT_CUSTOM_ROLE_STATUS_REQUEST:
      return {
        ...state,
        postCustomRoleLoading: true,
      };
    case ACTIONS.POST_CUSTOM_ROLE_RESPONSE:
    case ACTIONS.PUT_CUSTOM_ROLE_RESPONSE:
    case ACTIONS.PUT_CUSTOM_ROLE_STATUS_RESPONSE:
      return {
        ...state,
        postCustomRoleLoading: false,
        postCustomRoleResponse: action.payload,
      };
    case ACTIONS.POST_CUSTOM_ROLE_RESPONSE_CLEAR:
      return {
        ...state,
        postCustomRoleResponse: null,
      };
    //
    case ACTIONS.PUT_ROLE_BY_PERMISSION_REQUEST:
      return {
        ...state,
        putCustomRoleByPermissionLoading: true,
      };
    case ACTIONS.PUT_ROLE_BY_PERMISSION_RESPONSE:
      return {
        ...state,
        putCustomRoleByPermissionLoading: false,
        putCustomRoleByPermissionResponse: action.payload,
      };
    case ACTIONS.PUT_ROLE_BY_PERMISSION_RESPONSE_CLEAR:
      return {
        ...state,
        putCustomRoleByPermissionResponse: null,
      };
    //
    case ACTIONS.GET_ROLE_BY_PERMISSION_REQUEST:
      return {
        ...state,
        getCustomRoleByPermissionLoading: true,
      };
    case ACTIONS.GET_ROLE_BY_PERMISSION_RESPONSE:
      return {
        ...state,
        getCustomRoleByPermissionLoading: false,
        getCustomRoleByPermissionResponse: action.payload,
      };
    default:
      return state;
  }
};

export default SettingsReducer;
